module.exports = __webpack_public_path__ + "img/video-column-tit.1ec57e3d.png";